import { render, staticRenderFns } from "./edi.vue?vue&type=template&id=01f5c416&scoped=true&"
import script from "./edi.vue?vue&type=script&lang=js&"
export * from "./edi.vue?vue&type=script&lang=js&"
import style0 from "./edi.vue?vue&type=style&index=0&id=01f5c416&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f5c416",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f5c416')) {
      api.createRecord('01f5c416', component.options)
    } else {
      api.reload('01f5c416', component.options)
    }
    module.hot.accept("./edi.vue?vue&type=template&id=01f5c416&scoped=true&", function () {
      api.rerender('01f5c416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/edi.vue"
export default component.exports